import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { IUser } from '../../interfaces/IUser';
import { IMember } from '../../interfaces/IMember';
import { ITempImage } from '../../interfaces/ITempImage';

const apiUrl = Globals.apiPath + '/static';

export default class StaticService {
  constructor() {}

  async uploadImage(data: {
    b64: string;
    final?: boolean;
  }): Promise<ITempImage> {
    let res = await axios.post<ITempImage>(`${apiUrl}/uploadImage`, data);
    return res.data;
  }
}
